<style>
    .table {

        thead,
        tfoot {
            th {
                vertical-align: top;
                text-transform: none;
                font-size: 0.850rem;
                letter-spacing: 0.2px;
            }
        }

        th,
        td {
            padding: 0.6rem 1rem;
            vertical-align: middle;
        }

        &.table-sm {

            th,
            td {
                padding: 0.72rem 0.5rem;

                &:first-child {
                    padding-left: 0.75rem;
                }
            }
        }
    }

    .table-responsive {
        display: inline-table;
        width: 100%;
        overflow-x: auto;
    }
</style>
<loader *ngIf="showLoader"></loader>
<div class="content-wrapper  container-xxl p-0">
    <div class="content-body">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12 col-lg-12 col-xl-12 col-12 col-sm-12 col-xs-12 mb-20">
                        <div class="row">
                            <div class="col-md-12">
                                <h5 class="content-header-title float-left mb-10 fs-13">
                                    Encashment
                                </h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <encashment-esign *ngIf="!showESignIframe"></encashment-esign>
                                <div class="col-md-12 text-right pr-0">
                                    <button class="btn btn-primary btn-next mb-20" rippleEffect *ngIf="signatureMode == 'AADHAR_ESIGN' && !showESignIframe" (click)="A2FormProceed()">
                                        <span class="align-middle ">Proceed</span>
                                    </button>
                                </div>
                                <iframe *ngIf="showESignIframe" width="100%" height="500" [src]="url" id="adharesign" style="border:1px solid #bbb"></iframe>
                                <div class="col-md-12 text-right pr-0" *ngIf="showESignIframe">
                                    <button class="btn btn-primary btn-next mb-20" rippleEffect (click)="aadharEsignDocumentDetails()">
                                        <span class="align-middle ">Proceed</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="col-md-12 text-right">
                            <div (click)="downloadEncashmentForm()">
                                <a class="fs-10 fw-600 sky-blue-text">View encashment form </a>
                            </div>
                        </div> -->
                        <!-- <div class="row">
                            <div class="col-md-12 mt-10">
                                <div class="custom-control custom-checkbox mb-10">
                                    <input type="checkbox" style="color: black;" class="custom-control-input"
                                        id="encashmentCheckbox" [(ngModel)]="isChecked"
                                        (change)="otpRequestForEncashment(isChecked)" />
                                    <label class="custom-control-label fs-10" for="encashmentCheckbox"> {{tncText}}
                                        <a class="link" *ngIf="orderCardVendor == 'SMART_CARD'" target="_blank" href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/smartFxWebPortalDocuments/SmartCurrencyCard-TNC.pdf"> <span class="blue-text"> terms and conditions, </span> </a>
                                        <a class="link" *ngIf="orderCardVendor == 'STUDENT_CARD'" target="_blank" href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/smartFxWebPortalDocuments/SingleCurrCard-TNC.pdf"> <span class="blue-text"> terms and conditions, </span> </a>
                                        <a class="link" *ngIf="orderCardVendor == 'TRAVEL_CARD'" target="_blank" href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/smartFxWebPortalDocuments/SingleCurrCard-TNC.pdf"> <span class="blue-text"> terms and conditions, </span> </a>
                                        <a class="link" *ngIf="orderCardVendor == 'GLOBAL_CARD'" target="_blank" href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/smartFxWebPortalDocuments/SingleCurrCard-TNC.pdf"> <span class="blue-text"> terms and conditions, </span> </a>
                                        <a class="link" *ngIf="orderCardVendor == 'GLOBAL_MULTI_CARD'" target="_blank" href="https://s3.ap-south-1.amazonaws.com/files.wsfx.in/smartFxWebPortalDocuments/Global-Pay-Multi+Currency-Card-+Terms-and+-Conditions.pdf"> <span class="blue-text"> terms and conditions, </span> </a>
                                    </label>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 mt-20 fs-12 form-group">
                                <input type="text" class="form-control fs-12" placeholder="Enter OTP"
                                    [(ngModel)]='otpForEncashment' />
                                <div class="d-flex justify-content-between mt-5">
                                    <label></label>
                                    <a (click)="otpRequestForEncashment(true)"><small class="fs-10">Resend OTP</small></a>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <!-- <div class="col-md-6 col-lg-6 col-xl-6 col-6 col-sm-12 col-xs-12 mb-10 invoice-preview-wrapper" *ngIf="orderDetails">
                        <table class="table table-bordered table-responsive">
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Currency</th>
                                    <th>FX Amount</th>
                                    <th>Rate</th>
                                    <th>INR Amount</th>
                                </tr>
                            </thead>
                            <tbody class="fs-10 text-black">
                                <tr *ngFor="let singleTransaction of orderDetails?.orderItems; let i = index">
                                    <td>
                                        {{singleTransaction?.product}}
                                    </td>
                                    <td>
                                        {{singleTransaction?.currencyCode}}
                                    </td>
                                    <td>
                                        {{singleTransaction?.currencyAmount}}
                                    </td>
                                    <td>
                                        {{singleTransaction.sellRate | number :
                                        '1.2-2'}}
                                    </td>
                                    <td>
                                        {{singleTransaction.billableAmount}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="table-responsive mt-10 amout-breakup-bg">
                            <table class="table table-condensed table-borderless  fs-12">
                                <tbody>
                                   
                                    <tr>
                                        <td class="thick-line text-black fw-600" colspan="3"><strong>Amount</strong>
                                        </td>
                                        <td class="thick-line text-right text-black fw-600 "> ₹ {{
                                            orderDetails?.invoice?.billableAmountString }}
                                        </td>
                                    </tr>
                                   
                                    <tr>
                                        <td class="no-line " colspan="3"><strong>Service Charges </strong></td>
                                        <td *ngIf="!isSurrenderOrder" class="no-line text-right" >₹ {{orderDetails?.invoice?.totalHandlingChargesString}}
                                         <td *ngIf="isSurrenderOrder" class="no-line text-right" >- ₹ {{orderDetails?.invoice?.totalHandlingChargesString}}
                                    </tr>
                                    <tr>
                                        <td class="no-line " colspan="3"><strong>GST</strong></td>
                                        <td *ngIf="!isSurrenderOrder" class="no-line text-right" >₹ {{orderDetails?.invoice?.totalTaxesString}}
                                         <td *ngIf="isSurrenderOrder" class="no-line text-right" >- ₹ {{orderDetails?.invoice?.totalTaxesString}}
                                    </tr>

                                    <tr style="border-top:1px solid #bdbcbc">
                                        <td *ngIf="!isSurrenderOrder" class="no-line text-black fw-800 pt-10" colspan="3"> Total Payable </td>
                                        <td *ngIf="isSurrenderOrder" class="no-line text-black fw-800 pt-10" colspan="3"> Payment Receivable </td>

                                        <td class="no-line text-right text-black fw-800 pt-10"> ₹ {{
                                            orderDetails?.invoice?.totalBillAmountString }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div> -->
                <div class="row d-flex justify-content-between mt-20">
                    <!-- <div class="col-11">
                        <button type="button" class="btn btn-primary btn-back fs-12" rippleEffect routerLink="/cashout">
                            <span class="align-middle">Back</span>
                        </button>
                    </div>
                    <div class="col-1">
                        <button type="submit" class="btn btn-primary btn-next fs-12" (click)="validateOTP()"
                            rippleEffect>
                            <span class="align-middle">Next</span>
                        </button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>